<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    class="d-flex"
  >
    <path
      d="M 160 -120 v -375 l -72 55 l -48 -64 l 440 -336 l 440 336 l -48 63 l -72 -54 v 375 H 160 Z m 80 -80 h 480 v -356 L 480 -739 L 240 -556 v 356 Z h 480 Z Z Z Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'DashboardIcon',
};
</script>

